import { Injectable, signal } from '@angular/core';
import { videos } from './static/videos';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  videos = signal(videos);

  getVideos = (number?: number) => {
    if (number) {
      return this.videos().slice(0, number);
    } else {
      return this.videos();
    }
  };
}
